module.exports = __webpack_public_path__ + "img/28297b0.svg";